import { observer } from 'mobx-react-lite';
import { Route, Switch } from 'react-router-dom';
import { BasePage, PageType } from 'src/components/BasePage';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { NotificationProcessPage } from 'src/pages/SettingsPage/components/NotificationTemplatesDetails/components/NotificationProcessPage';
import { NotificationTemplateEdit } from 'src/pages/SettingsPage/components/NotificationTemplatesDetails/components/NotificationTemplateEdit';
import { NotificationTemplateList } from 'src/pages/SettingsPage/components/NotificationTemplatesDetails/components/NotificationTemplateList';

export const NotificationTemplatesDetails = observer(() => {
    return (
        <BasePage
            pageName="setting-notification-templates"
            type={PageType.FULL}
        >
            <Switch>
                <Route
                    exact
                    path={RoutePaths.settingsNotificationTemplateList}
                    component={NotificationTemplateList}
                />
                <Route
                    exact
                    path={RoutePaths.settingsNotificationTemplateEdit}
                    component={NotificationTemplateEdit}
                />
                <Route
                    path={`${RoutePaths.settingsNotificationTemplateList}/:id/process/:processKey`}
                    exact
                    component={NotificationProcessPage}
                />
            </Switch>
        </BasePage>
    );
});
